import type { Sku } from '@/types/interfaces/sku'

/** Default bullet copy aligned with `DetailPageBulletPoints` when refresh config omits `bulletPoints`. */
export function getSkuRefreshDefaultBulletTexts(sku: Sku): string[] {
    const isLabPanelSku = sku?.category === 'lab'
    const isPrescriptionSku = sku?.category === 'medication'

    if (isLabPanelSku) {
        return (sku.lab_details?.bullet_points ?? []).map((p) => p.text)
    }

    if (isPrescriptionSku) {
        return [
            'Licensed providers in all 50 states',
            'Expert-guided, evidence-based treatments',
            'Skip the trip to the doctor\u2019s office',
        ]
    }

    return [
        'Licensed providers in all 50 states',
        'Most insurance & self-pay accepted',
        'Skip the trip to the doctor\u2019s office',
    ]
}
